import React from 'react'

import { LntModal } from '@app/components/base'

import { ConfirmModalProps } from './types'

export const ConfirmModal: React.FC<ConfirmModalProps> = props => {
  const { onConfirm, title, okText = 'Да', cancelText = 'Нет', ...restProps } = props

  return (
    <LntModal
      { ...restProps }
      title={ title }
      onOk={ onConfirm }
      okText={ okText }
      cancelText={ cancelText }
    />
  )
}
